import ReactTooltip from "react-tooltip";
import Division from "../../../components/Division";
import Header from "../../../components/Header";
import Lateral from "../../../components/Lateral";
import { useEffect, useState } from "react";
import { FaCalendar, FaCog, FaEye, FaPen, FaSearch } from "react-icons/fa";
import { checkWhichIconMustToBeReturned, convertDateAndHour, getListFromFlow, getPermission, showMessageError } from "../../../classes/functions";
import { Link } from 'react-router-dom';
import api from "../../../config";
import { toast } from "react-toastify";
import Modal from 'react-modal';
import ModalStatus from "../../../components/Modal/ModalStatus";
import Title from "../../../components/Title";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import SelectStatus from "../../../components/Select/SelectStatus";
import StatusButton from "../../../components/StatusButton";

export default function EPIRequests() {
  const [showSelectStatus, setShowSelectStatus] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [carrying, setCarrying] = useState(true);
  const [EPIRequests, setEPIRequests] = useState([]);
  const [filteredEPIRequests, setFilteredEPIRequests] = useState([]);
  const [EPIRequestId, setEPIRequestId] = useState(0);
  const [listStatus, setListStatus] = useState([{ label: 'FERRAMENTAS', value: 'FERRAMENTAS' }, { label: 'EPIs', value: 'EPIs' }]);
  const [statusButtonWasClicked, setStatusButtonWasClicked] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [listChangeStatus, setListChangeStatus] = useState([]);
  const [itemChange, setItemChange] = useState({});
  const [pesquisa_status, setPesquisaStatus] = useState('');
  const [search, setSearch] = useState('');
  const [showDatesModal, setShowDatesModal] = useState(false);
  const [listItemsForApproval, setListItemsForApproval] = useState([]);
  const [qtdePage, setQtdePage] = useState(50);
  const [limitPage, setLimitPage] = useState(1);
  const [page, setPage] = useState(1);
  const [novo_status, setNovoStatus] = useState('');

  const approvedOrDenied = [
    {
      id: 1,
      label: 'Aprovado',
      value: 'Aprovado'
    },
    {
      id: 2,
      label: 'Negado',
      value: 'Negado'
    }
  ];

  function openModalToEvaluate(item) {
    setItemChange(() => item);
    setListChangeStatus(getListFromFlow(item.fluxo, listStatus));

    api.get("/api/epi/product_requests/getItemsForApproval?id=" + item.id)
      .then((response) => {
        setListItemsForApproval(response.data.list);
        setModalStatus(true);
      }).catch((error) => {
        showMessageError(error.response.data);
      });
  }

  function getEPIRequests(qtdePageParam) {
    setCarrying(false);

    let param = "";

    if(search || selectedStatus){
      param = `?search=${search}&status=${selectedStatus}`;
    }

    api
      .get(`/api/epi/product_request?page=${page}&limit=${qtdePage}&${param}`, {
        headers: {
          empresa: localStorage.empresa,
          usuario: localStorage.usuario
        }
      })
      .then((response) => {
        setEPIRequests(response.data.result);
        setFilteredEPIRequests(response.data.result);
        setLimitPage(parseInt(response.data.total / qtdePage) + 1);

        setStatusButtonWasClicked(false);
        setShowSelectStatus(false);

        setCarrying(false);
      })
      .catch((error) => {
        console.log(error)
      })
  }

  function changeStatus() {
    if (novo_status === '') {
      toast.error('Selecione um status.');    
    } else if (novo_status === 'Aprovado') {
      let data = {
        data: {
          items: listItemsForApproval
        }
      };
      
      api
        .put(`/api/epi/product_request/${itemChange.id}/approve`, data)
        .then((response) => {
          getEPIRequests('');
          setModalStatus(false);
          toast.success('Aprovação realizada com sucesso!');
        })
        .catch((error) => {
          console.log(error);
          showMessageError(error.response.data);
        });
    } else if (novo_status === 'Negado') {
      api
        .put(`/api/epi/product_request/${itemChange.id}/deny`)
        .then((response) => {
          getEPIRequests('');
          setModalStatus(false);
          toast.success('Aprovação revertida com sucesso!');
        })
        .catch((error) => {
          console.log(error)
          showMessageError(error.response.data);
        });
    }
  }

  const customStyles = {
    content: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      right: 'auto',
      width: '750px',
      maxHeight: '80%',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  useEffect(() => {
    api.get("/api/generics/getItens?table=7Y")
      .then((response) => {
        setListStatus(response.data);
      }).catch((error) => {
        showMessageError(error.response.data);
      });

    return () => {

    }
  }, []);

  useEffect(() => {
    if(page || qtdePage || search){
      getEPIRequests('');
    }
  }, [, page, qtdePage, search]);

  useEffect(() => {
    if(statusButtonWasClicked){
      getEPIRequests('');
    }
  }, [statusButtonWasClicked])

  useEffect(() => {
    if (pesquisa_status !== '') {
      setFilteredEPIRequests(EPIRequests.filter((EPIRequest) => EPIRequest.status === pesquisa_status));
    } else {
      setFilteredEPIRequests(EPIRequests);
    }
  }, [pesquisa_status]);

  useEffect(() => {
    if (modalStatus === false) {
      setNovoStatus('');
    }
  }, [modalStatus]);

  useEffect(() => {
    setPage(1);
  }, [qtdePage]);

  return (
    <div>
      <Header />
      <Division />
      <Lateral />
      <ReactTooltip />

      <Modal
        isOpen={showDatesModal}
        onRequestClose={() => setShowDatesModal(false)}
        style={customStyles}
        contentLabel="Conferência"
        ariaHideApp={false}
      >
        <div>
          <h2 style={{ fontSize: '1.75rem', fontWeight: '400', marginBottom: '1rem' }}>Datas</h2>
          <table>
            <thead>
              <tr>
                <th>Aprovação</th>
                <th>Devolução</th>
                <th>Retirada</th>
                <th>Separação</th>
              </tr>
            </thead>
            <tbody>
              {EPIRequests?.map((EPIRequest, index) => {
                if (EPIRequest.id === EPIRequestId) {
                  return (
                    <tr key={index}>
                      <td>{EPIRequest.data_aprovacao ? convertDateAndHour(EPIRequest.data_aprovacao).slice(0, 10) : 'Não informado.'}</td>
                      <td>{EPIRequest.data_devolucao ? convertDateAndHour(EPIRequest.data_devolucao).slice(0, 10) : 'Não informado.'}</td>
                      <td>{EPIRequest.data_retirada ? convertDateAndHour(EPIRequest.data_retirada).slice(0, 10) : 'Não informado.'}</td>
                      <td>{EPIRequest.data_separacao ? convertDateAndHour(EPIRequest.data_separacao).slice(0, 10) : 'Não informado.'}</td>
                    </tr>
                  )
                }
              })}
            </tbody>
          </table>
        </div>
      </Modal>

      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Requisição de EPIs">
          <Link to="/epis_requests/cadastrar">
            <button className="buttonInsert">
              Cadastrar
            </button>
          </Link>
          <select className='selectQtdeItens' value={qtdePage} onChange={(e) => { setQtdePage(e.target.value) }}>
            <option value="50">Itens por página</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
          <input className="inputSearch" type="text" onChange={(e) => setSearch(e.target.value)} placeholder="Search" />
          <FaSearch className="iconSearch" style={{ color: '#001675' }} size={16} />
        </Title>
        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">
                  <StatusButton
                    showSelectStatus={showSelectStatus} 
                    setShowSelectStatus={setShowSelectStatus} 
                    listStatus={listStatus} 
                    setListStatus={setListStatus} 
                    selectedStatus={selectedStatus} 
                    setSelectedStatus={setSelectedStatus} 
                    setStatusButtonWasClicked={setStatusButtonWasClicked} 
                  />
                </th>
                <th scope="col">Datas</th>
                <th scope="col">Data</th>
                <th scope="col">Hora</th>
                <th scope="col">Solicitante</th>
                <th scope="col">Aprovador</th>
                <th scope="col">Destinatário</th>
                <th scope="col">Recebedor</th>
                <th scope="col">Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredEPIRequests?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td data-label="">{item?.id}</td>
                    <td title={item?.descricao_status?.toUpperCase()} data-label="">{checkWhichIconMustToBeReturned(item?.descricao_status?.toUpperCase(), "2rem")}</td>
                    <td data-label="" onClick={() => {
                      setEPIRequestId(item?.id);
                      setShowDatesModal(true);
                    }}><FaCalendar /></td>
                    <td data-label="">{convertDateAndHour(item?.created_at).slice(0, 10)}</td>
                    <td data-label="">{convertDateAndHour(item?.created_at).slice(11, 19)}</td>
                    <td data-label="">{item?.solicitado_por?.nome}</td>
                    <td data-label="">{item.aprovador ? item?.aprovador?.nome : ''}</td>
                    <td data-label="">{item?.solicitado_para?.nome}  {item?.solicitado_para?.sobrenome}</td>
                    <td data-label="">{item?.recebedor?.nome}</td>
                    <td data-label="Opções" style={{ display: 'flex' }}>
                      {getPermission('OPERACOES - REQUISICOES EPIS - APROVACAO') && ['001'].indexOf(item?.status) > -1 && item?.fluxo != '' && <Link to style={{ backgroundColor: 'inherit' }} className="action" onClick={() => openModalToEvaluate(item)} >
                        <FaCog color="#000" size={17} data-tip="Avaliar Solicitação" />
                      </Link>}
                      <ReactTooltip />
                      {getPermission('OPERACOES - REQUISICOES EPIS - CADASTRO') && <Link style={{ backgroundColor: 'inherit' }} className="action" to={`/epis_requests/cadastrar/u${item.id}`} >
                        <FaPen color="#000" size={17} data-tip="Editar" />
                      </Link>}
                      <ReactTooltip />
                      <Link style={{ backgroundColor: 'inherit'}} className="action" to={`/epis_requests/cadastrar/v${item?.id}`} >
                        <FaEye color="#000" size={19} data-tip="Visualizar" />
                      </Link>
                      <ReactTooltip />
                    </td>
                  </tr>
                )
              })}
              {filteredEPIRequests?.length == 0 && <tr>
                <td colSpan={8}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
          <br />
          <div className="divGroupPagination">
            <button data-tip="Primeira página" onClick={() => setPage(1)} type="button" className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
            <button data-tip="Página anterior" onClick={() => setPage(page > 1 ? page - 1 : 1)} type="button" className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
            <div className="divLabelPagination">
              <center><label className="labelPage">Exibindo página {page} de {limitPage}</label></center>
            </div>
            <button data-tip="Próxima página" onClick={() => setPage((page + 1) < limitPage ? page + 1 : limitPage)} type="button" className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
            <button data-tip="Última página" onClick={() => setPage(limitPage)} type="button" className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
          </div>
        </div>
      </div>
      }

      <ModalStatus modalStatus={modalStatus} setModalStatus={setModalStatus} newStatus={novo_status} setNewState={setNovoStatus} states={approvedOrDenied} changeStatus={changeStatus} listItems={listItemsForApproval}></ModalStatus>
    </div>
  )
}